/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ConditionalRuleIcon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 16, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="ConditionalRuleIcon"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M7.5 7V2H8.5V7H11.5C12.3284 7 13 7.67157 13 8.5V12.2929L14.6464 10.6464L15.3536 11.3536L12.5 14.2071L9.64645 11.3536L10.3536 10.6464L12 12.2929V8.5C12 8.22386 11.7761 8 11.5 8H4.5C4.22386 8 4 8.22386 4 8.5V12.2929L5.64645 10.6464L6.35355 11.3536L3.5 14.2071L0.646446 11.3536L1.35355 10.6464L3 12.2929V8.5C3 7.67157 3.67157 7 4.5 7H7.5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

ConditionalRuleIcon.tags = ['branch', 'decision', 'flow', 'split', 'path'];

ConditionalRuleIcon.category = 'General Icons';

ConditionalRuleIcon.iconSize = 16;
